import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ClienteMobileUser } from '@/types/clienteMobile';

interface ClienteAuthState {
  user: ClienteMobileUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  previewMode: boolean;
  setSession: (user: ClienteMobileUser, accessToken: string, refreshToken: string) => void;
  setPreviewSession: (user: ClienteMobileUser, accessToken: string, refreshToken: string) => void;
  setTokens: (accessToken: string, refreshToken: string) => void;
  setUser: (user: ClienteMobileUser | null) => void;
  logout: () => void;
}

export const useClienteAuthStore = create<ClienteAuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      previewMode: false,

      setSession: (user, accessToken, refreshToken) =>
        set({
          user,
          accessToken,
          refreshToken,
          isAuthenticated: true,
          previewMode: false,
        }),

      setPreviewSession: (user, accessToken, refreshToken) =>
        set({
          user,
          accessToken,
          refreshToken,
          isAuthenticated: true,
          previewMode: true,
        }),

      setTokens: (accessToken, refreshToken) =>
        set({
          accessToken,
          refreshToken,
        }),

      setUser: (user) => set({ user }),

      logout: () =>
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          isAuthenticated: false,
          previewMode: false,
        }),
    }),
    {
      name: 'cliente-auth-storage',
      partialize: (s) => ({
        user: s.user,
        accessToken: s.accessToken,
        refreshToken: s.refreshToken,
        isAuthenticated: s.isAuthenticated,
        previewMode: s.previewMode,
      }),
    }
  )
);
